// extracted by mini-css-extract-plugin
module.exports = {"ManageReport":"ManageReport_ManageReport__FFnZs"};